import { useCallback, useEffect, useState } from 'react';
import type { Menu, MenuListItem } from '@ricettario/shared';
import { api, ApiError } from '../api/client';

type State<T> = { data: T | null; loading: boolean; error: string | null };

export function useMenus() {
  const [state, setState] = useState<State<MenuListItem[]>>({
    data: null,
    loading: true,
    error: null,
  });

  const refresh = useCallback(async () => {
    setState((s) => ({ ...s, loading: true, error: null }));
    try {
      const data = await api.get<MenuListItem[]>('/api/v1/menus');
      setState({ data, loading: false, error: null });
    } catch (err) {
      setState({
        data: null,
        loading: false,
        error: err instanceof ApiError ? err.message : 'errore',
      });
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { ...state, refresh };
}

export function useMenu(id: string | undefined) {
  const [state, setState] = useState<State<Menu>>({ data: null, loading: true, error: null });

  const refresh = useCallback(async () => {
    if (!id) return;
    setState((s) => ({ ...s, loading: true, error: null }));
    try {
      const data = await api.get<Menu>(`/api/v1/menus/${id}`);
      setState({ data, loading: false, error: null });
    } catch (err) {
      setState({
        data: null,
        loading: false,
        error: err instanceof ApiError ? err.message : 'errore',
      });
    }
  }, [id]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { ...state, refresh };
}
